// Widget Scripts
import slideshow from './js/widgets/slideshow.js';
import cardWidget from './js/widgets/cardWidget.js';
import videoWidget from './js/widgets/videoWidget.js';
import seoWidget from './js/widgets/seoWidget.js';
import autoEvents from './js/widgets/autoEvents.js';
import scrollerSponsorsDouble from './js/widgets/scrollerSponsorsDouble.js';
import footerLinks from './js/widgets/footerLinks.js';

// Custom Theme Scripts
import './js/localjs.js';

// Theme Controller
import { themeController } from './js/themeController.js';

// Initialize Homepage Widgets
$(document).ready(function () {
  footerLinks('communityLinks', communityLinksOpts, 'Community Links');
  footerLinks('moreAboutFairsLinks', moreAboutFairsLinksOpts, 'More About Fairs');

  if (globalThis.location.pathname === '/') {
    slideshow('slideshow', slideshowOpts);
    cardWidget('cardWidget', cardWidgetOpts, 5);
    cardWidget('hotButton', hotButtonOpts, 6);
    seoWidget('seoWidget', seoWidgetOpts);
    autoEvents();
    scrollerSponsorsDouble('scroller-sponsors', scrollerSponsorsOpts, 4);
    $(globalThis).load(function () {
      videoWidget('videoWidget', videoWidgetOpts);
    });
  }

  themeController(themeData);
});
